/* ============================================================
   TheTransformationLab — site engine
   smooth scroll · cursor · reveals · gallery · slider · accordion
   No dependencies.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* ============================================================
     IMAGE LIBRARY — pulled from the live store CDN
     ============================================================ */
  var CDN = 'https://www.thetransformationlab.in/cdn/shop/files/';
  // ?demo=1 swaps in local placeholder tiles (used only for offline previews)
  var DEMO = /[?&]demo=1/.test(location.search);
  var W = function (f, w) {
    if (DEMO) {
      var i = PEOPLE.indexOf(f);
      if (i > -1) return 'demo/p' + i + '.jpg';
      for (var k = 0; k < PRODUCTS.length; k++) if (PRODUCTS[k].f === f) return 'demo/prod' + k + '.jpg';
      return 'demo/hero.jpg';
    }
    return CDN + f + '&width=' + (w || 800);
  };

  var PEOPLE = [
    '9d91379a-33ba-42ee-9fbd-0a35a7798dc5.jpg?v=1785766762',
    'f6761cdc-1469-43d4-8d64-ca60807191c7.jpg?v=1785766759',
    'WhatsApp_Image_2026-07-31_at_10.35.42_AM.jpg?v=1785766756',
    '01751c86-0e46-4725-997e-fdec6ddcd1fb.jpg?v=1785766754',
    'a74a1e31-b318-4866-bf57-545392306303.jpg?v=1785766751',
    'e337ed0c-923e-4132-bcd3-cf83b0f14e98.jpg?v=1785766749',
    'WhatsApp_Image_2026-07-31_at_10.35.27_AM_2.jpg?v=1785765990',
    'WhatsApp_Image_2026-07-31_at_10.35.28_AM.jpg?v=1785765984',
    'WhatsApp_Image_2026-07-31_at_10.35.28_AM_1.jpg?v=1785765977',
    'WhatsApp_Image_2026-07-31_at_10.35.31_AM.jpg?v=1785765974',
    'WhatsApp_Image_2026-07-31_at_10.35.32_AM.jpg?v=1785765971',
    'WhatsApp_Image_2026-07-31_at_10.35.40_AM.jpg?v=1785765969',
    'WhatsApp_Image_2026-07-31_at_10.35.41_AM.jpg?v=1785765966',
    'WhatsApp_Image_2026-07-31_at_10.35.21_AM.jpg?v=1785765843',
    'WhatsApp_Image_2026-07-31_at_10.35.22_AM_1.jpg?v=1785765836',
    'WhatsApp_Image_2026-07-31_at_10.35.22_AM.jpg?v=1785765840',
    'b744f015-e540-4c98-be7a-bd64be1afc76.jpg?v=1785425271',
    'WhatsApp_Image_2026-07-31_at_10.35.16_AM.jpg?v=1785765768',
    'WhatsApp_Image_2026-07-31_at_10.35.23_AM.jpg?v=1785765831',
    'WhatsApp_Image_2026-07-31_at_10.35.23_AM_1.jpg?v=1785765828',
    'WhatsApp_Image_2026-07-31_at_10.35.17_AM.jpg?v=1785765764',
    'WhatsApp_Image_2026-07-31_at_10.35.22_AM_2.jpg?v=1785765833',
    'Screenshot_1868.png?v=1786723445',
    'Screenshot_1867_a96627ce-76cd-4bb8-bec7-4e27373f08f6.png?v=1786723344'
  ];
  var HERO_SHOT = 'WhatsApp_Image_2026-08-14_at_9.04.05_PM.jpg?v=1786721670';
  var PRODUCTS = [
    { f: 'a798f5a4f568beff4d53bb74bf513b9a.png?v=1785767587', t: 'App Dashboard With Progress Tracking', p: 79 },
    { f: 'e49574c9e019de25429e693773e1c65b_9401ad4f-510b-4cca-8144-6b0b77607343.png?v=1785424591', t: 'Personalized Nutrition Digital Guide', p: 49 },
    { f: '1958e34d6f2c8c353799e8560a031049_68e89094-dd72-4588-b3ee-7b09f25b7f94.png?v=1785424589', t: 'One-on-One Virtual Coaching Session', p: 119 },
    { f: '622d353d5b70fd570325a560e564361d.png?v=1785767590', t: 'Motivational Community Feed Success Stories', p: 29 }
  ];
  var LABELS = ['Transformation Journey', 'Wellness Journey', 'Fitness Journey',
    'Health Journey', 'Strength Journey', 'Success Journey'];

  // Client story videos — served from the site's own /media folder
  var VIDEOS = [
    { f: 'v1', dur: '0:42' },
    { f: 'v2', dur: '0:37' },
    { f: 'v3', dur: '0:29' },
    { f: 'v4', dur: '0:48' },
    { f: 'v5', dur: '1:30' }
  ];

  window.TLAB = { CDN: CDN, W: W, PEOPLE: PEOPLE, HERO_SHOT: HERO_SHOT,
    PRODUCTS: PRODUCTS, LABELS: LABELS, VIDEOS: VIDEOS };

  function figure(file, w, cls) {
    return '<div class="ph ' + (cls || '') + '">' +
      '<img loading="lazy" decoding="async" alt="Transformation journey" ' +
      'src="' + W(file, w) + '"></div>';
  }
  window.TLAB.figure = figure;

  /* ============================================================
     PRELOADER
     ============================================================ */
  var pre = document.querySelector('.pre');
  document.body.classList.add('loading');
  function killPre() {
    if (!pre) { document.body.classList.remove('loading'); return; }
    pre.classList.add('is-done');
    document.body.classList.remove('loading');
    setTimeout(function () { pre && pre.remove(); }, 700);
  }
  if (pre) {
    var bar = pre.querySelector('.pre__bar i'), num = pre.querySelector('.pre__num');
    var v = 0, done = false;
    var tick = setInterval(function () {
      v += Math.random() * 13 + 5;
      if (v >= 100) { v = 100; clearInterval(tick); }
      if (bar) bar.style.width = v + '%';
      if (num) num.textContent = String(Math.round(v)).padStart(3, '0');
      if (v === 100 && !done) { done = true; setTimeout(kickOff, 320); }
    }, 105);
  } else {
    addEventListener('load', kickOff);
  }
  function kickOff() {
    killPre();
    root.classList.add('is-ready');
    document.querySelectorAll('.hero .mask,.hero .rv').forEach(function (el, i) {
      setTimeout(function () { el.classList.add('in'); }, 90 * i);
    });
  }
  setTimeout(function () { if (document.body.classList.contains('loading')) kickOff(); }, 4200);

  /* ============================================================
     SMOOTH SCROLL (desktop) — drives the native scroll position
     so position:sticky and IntersectionObserver keep working.
     ============================================================ */
  if (fine && !reduce) {
    var target = window.scrollY, current = window.scrollY, ticking = false;
    function maxY() { return document.documentElement.scrollHeight - innerHeight; }
    addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;
      var n = e.target;
      while (n && n !== document.body) {
        if (n.hasAttribute && n.hasAttribute('data-native')) return;
        n = n.parentElement;
      }
      e.preventDefault();
      target = Math.min(Math.max(target + e.deltaY * (e.deltaMode === 1 ? 18 : 1), 0), maxY());
      if (!ticking) { ticking = true; requestAnimationFrame(run); }
    }, { passive: false });
    function run() {
      current += (target - current) * 0.115;
      if (Math.abs(target - current) < .4) { current = target; ticking = false; }
      window.scrollTo(0, current);
      if (ticking) requestAnimationFrame(run);
    }
    addEventListener('scroll', function () {
      if (!ticking) { target = current = window.scrollY; }
    }, { passive: true });
    addEventListener('resize', function () { target = current = window.scrollY; });
  }

  /* ============================================================
     CURSOR
     ============================================================ */
  if (fine) {
    var c1 = document.createElement('div'); c1.className = 'cursor';
    var c2 = document.createElement('div'); c2.className = 'cursor-dot';
    document.body.append(c1, c2);
    var cx = innerWidth / 2, cy = innerHeight / 2, dx = cx, dy = cy;
    addEventListener('pointermove', function (e) {
      dx = e.clientX; dy = e.clientY;
      c2.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)';
    }, { passive: true });
    (function loop() {
      cx += (dx - cx) * .16; cy += (dy - cy) * .16;
      c1.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('a,button,.prow,.card,.g,.strip__item');
      c1.classList.toggle('is-hot', !!t);
      var d = e.target.closest && e.target.closest('.ba');
      c1.classList.toggle('is-drag', !!d);
    });
  }

  /* ============================================================
     NAV
     ============================================================ */
  var nav = document.querySelector('.nav');
  var prog = document.querySelector('.prog');
  var lastY = 0;
  function onScroll() {
    var y = window.scrollY;
    if (nav) {
      nav.classList.toggle('is-solid', y > 40);
      nav.classList.toggle('is-hidden', y > 620 && y > lastY && !menuOpen);
    }
    if (prog) {
      var h = document.documentElement.scrollHeight - innerHeight;
      prog.style.width = (h > 0 ? (y / h) * 100 : 0) + '%';
    }
    lastY = y;
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var burger = document.querySelector('.burger'), menu = document.querySelector('.menu'), menuOpen = false;
  if (burger && menu) {
    burger.addEventListener('click', function () {
      menuOpen = !menuOpen;
      burger.classList.toggle('is-open', menuOpen);
      menu.classList.toggle('is-open', menuOpen);
      document.body.style.overflow = menuOpen ? 'hidden' : '';
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menuOpen = false; burger.classList.remove('is-open');
        menu.classList.remove('is-open'); document.body.style.overflow = '';
      });
    });
  }

  /* ============================================================
     REVEALS
     ============================================================ */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: .12, rootMargin: '0px 0px -8%' });
  function watchReveals(scope) {
    (scope || document).querySelectorAll('.rv:not(.in),.mask:not(.in)').forEach(function (el) {
      if (el.closest('.hero')) return;
      io.observe(el);
    });
  }
  window.TLAB.watchReveals = watchReveals;

  /* ---------- word-by-word lit text ---------- */
  document.querySelectorAll('[data-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="word">' + w + '</span>'; }).join(' ');
  });
  var litEls = Array.prototype.slice.call(document.querySelectorAll('[data-words]'));
  function litScroll() {
    litEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var start = innerHeight * .88, end = innerHeight * .28;
      var p = (start - r.top) / (start - end);
      p = Math.min(Math.max(p, 0), 1);
      var ws = el.querySelectorAll('.word');
      var n = Math.round(p * ws.length);
      for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('lit', i < n);
    });
  }
  if (litEls.length) { addEventListener('scroll', litScroll, { passive: true }); litScroll(); }

  /* ---------- parallax ---------- */
  var para = Array.prototype.slice.call(document.querySelectorAll('[data-para]'));
  function paraScroll() {
    para.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > innerHeight + 200) return;
      var s = parseFloat(el.dataset.para) || .12;
      var off = (r.top + r.height / 2 - innerHeight / 2) * -s;
      el.style.transform = 'translate3d(0,' + off.toFixed(2) + 'px,0)';
    });
  }
  if (para.length && !reduce) { addEventListener('scroll', paraScroll, { passive: true }); paraScroll(); }

  /* ---------- counters ---------- */
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, to = parseFloat(el.dataset.count), pre2 = el.dataset.pre || '', suf = el.dataset.suf || '';
      var t0 = performance.now(), dur = 1400;
      (function step(now) {
        var p = Math.min((now - t0) / dur, 1);
        p = 1 - Math.pow(1 - p, 3);
        el.textContent = pre2 + Math.round(to * p) + suf;
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    });
  }, { threshold: .5 });
  document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

  /* ---------- image load state ---------- */
  function bindImages(scope) {
    (scope || document).querySelectorAll('.ph img').forEach(function (img) {
      var p = img.parentElement;
      if (img.complete && img.naturalWidth) { p.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { p.classList.add('is-loaded'); });
      img.addEventListener('error', function () {
        // A photo that no longer exists in Shopify Files should vanish
        // completely rather than leave a broken tile in the gallery.
        p.classList.add('is-loaded');
        var tile = p.closest('.g, .strip__item, .prod');
        if (tile && tile.parentElement) tile.remove();
        else img.style.display = 'none';
      });
    });
  }
  window.TLAB.bindImages = bindImages;

  /* ---------- magnetic buttons ---------- */
  if (fine && !reduce) {
    document.querySelectorAll('[data-mag]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .22).toFixed(1) +
          'px,' + ((e.clientY - r.top - r.height / 2) * .3).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
      el.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1)';
    });
  }

  /* ============================================================
     TILT — a photograph that lifts off the page
     Pointer only. On touch the card stays flat, because a tilt you
     cannot control just reads as a rendering glitch.
     ============================================================ */
  if (fine && !reduce) {
    document.querySelectorAll('.tilt').forEach(function (wrap) {
      var card = wrap.querySelector('.tilt__in');
      if (!card) return;
      var raf = null, tx = 0, ty = 0, cx = 0, cy = 0, on = false;
      function run() {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        card.style.transform = 'rotateX(' + cy.toFixed(2) + 'deg) rotateY(' + cx.toFixed(2) +
          'deg) translateZ(' + (on ? 18 : 0) + 'px)';
        if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) raf = requestAnimationFrame(run);
        else raf = null;
      }
      function kick() { if (!raf) raf = requestAnimationFrame(run); }
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 13;
        ty = -((e.clientY - r.top) / r.height - 0.5) * 9;
        kick();
      });
      wrap.addEventListener('pointerenter', function () { on = true; wrap.classList.add('lit'); kick(); });
      wrap.addEventListener('pointerleave', function () {
        on = false; tx = 0; ty = 0; wrap.classList.remove('lit'); kick();
      });
    });
  }

  /* ---------- accordion ---------- */
  document.querySelectorAll('.acc__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.acc__item'), panel = item.querySelector('.acc__a');
      var open = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.acc__item.is-open').forEach(function (o) {
        o.classList.remove('is-open'); o.querySelector('.acc__a').style.height = '0px';
      });
      if (!open) { item.classList.add('is-open'); panel.style.height = panel.scrollHeight + 'px'; }
    });
  });

  /* ---------- before / after slider ---------- */
  document.querySelectorAll('.ba').forEach(function (ba) {
    var right = ba.querySelector('.ba__r'), bar = ba.querySelector('.ba__bar'),
        knob = ba.querySelector('.ba__knob'), down = false;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = Math.min(Math.max((x - r.left) / r.width, .02), .98) * 100;
      right.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      bar.style.left = p + '%'; knob.style.left = p + '%';
    }
    ba.addEventListener('pointerdown', function (e) { down = true; ba.setPointerCapture(e.pointerId); set(e.clientX); });
    ba.addEventListener('pointermove', function (e) { if (down) set(e.clientX); });
    ba.addEventListener('pointerup', function () { down = false; });
    ba.addEventListener('pointercancel', function () { down = false; });
  });

  /* ---------- anchor smooth ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (id.length < 2) return;
    var t = document.querySelector(id);
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  });

  /* ---------- year ---------- */
  document.querySelectorAll('[data-year]').forEach(function (e) { e.textContent = new Date().getFullYear(); });

  /* ---------- boot ---------- */
  document.addEventListener('tlab:render', function () { bindImages(); watchReveals(); });
  watchReveals(); bindImages();
})();
